module.exports = __webpack_public_path__ + "img/Partners 12.1c74441e.png";